export default __webpack_public_path__ + "static/media/redtick.9a094190.svg";